module.exports = __webpack_public_path__ + "static/media/SeaFarerInternetService2.d81da76d.png";